export const handleSuccessResponse = (response: any) => {
    return{ 
        success : true,
        data: response.data,
        message: response.data?.message || "Request successful"
    }
}

export const handleErrorResponse = (error: any) => {
    return {
        success: false,
        message: error.response?.data?.message || error?.message || "Unknown error",
        data: null
    }
}